<div class="container-fluid">

  <ul class="nav nav-tabs nav-tabs-custom" id="ULTabul">
    <li class="nav-item"><a class="nav-link active" data-toggle="tab" name="metrics-display" href="#divmetricsdisplay">Metrics Display</a></li>
    <li class="nav-item"
        *ngIf="(aproductivityL?.length || 0) > 0 || (aOccupancyL?.length || 0) > 0">
      <a class="nav-link" data-toggle="tab" name="Consecutive-display" href="#divConsecutive">
        Consecutive Report
      </a>
    </li>    <li class="nav-item"><a class="nav-link" data-toggle="tab" name="Approval" href="#divApproval">Approval</a></li>
  </ul><br />
       <div class="tab-content">

         <div class="tab-pane active" id="divmetricsdisplay" style="height: 78vh; overflow: hidden;">
           <div id="divFilter" class="row">
             <div class="col-sm-2">
               <div class="form-group">
                 <label for="ddlMonthRange">Month Range</label>
                 <select id="ddlMonthRange"
                         class="form-control"
                         [(ngModel)]="selectedMonthRange"
                         (change)="onMonthRangeChange()">
                   <option value="1">Current Month</option>
                   <option value="3">3 Month</option>
                   <option value="6">6 Month</option>
                   <option value="12">12 Month</option>
                   <option value="0">Custom</option>
                 </select>
               </div>
             </div>

             <div class="col-sm-2" *ngIf="showCustomRange">
               <div class="form-group">
                 <label for="txtFromDt">From Date</label>
                 <input type="date" class="form-control" id="txtFromDt">
               </div>
             </div>

             <div class="col-sm-2" *ngIf="showCustomRange">
               <div class="form-group">
                 <label for="txtToDt">To Date</label>
                 <input type="date" class="form-control" id="txtToDt">
               </div>
             </div>

             <div class="col-sm-2">
               <button type="button" id="btnKpiLoad"
                       class="btn btn-outline-info waves-effect waves-light clsMargin"
                       (click)="DashmetricsData()"
                       title="Get">
                 Search
               </button>
               <button type="button"
                       class="btn btn-outline-danger waves-effect waves-light clsMargin"
                       title="Clear"
                       (click)="ResetFilter()"
                       style="margin-left:10px">
                 Reset
               </button>
             </div>
           </div>
           <div style="height: 95%; overflow-y: auto; padding-right: 0.5rem;">

             <!-- Overall Metrics -->
             <app-Empmetrics-display [data]="aOverAll" [groupLabel]="'Overall'" [groupBy]="'Department'" chartTitle="Overall Metrics Overview"></app-Empmetrics-display>

             <!-- Department Wise -->
             <app-Empmetrics-display [data]="aDepartmentL" [groupLabel]="'Department'" [groupBy]="'Department'" chartTitle="Department Wise Metrics"></app-Empmetrics-display>

             <!-- Account Wise -->
             <!--<app-Empmetrics-display [data]="metricsData2" [groupLabel]="'account'" [groupBy]="'account'" chartTitle="Account Wise Metrics"></app-Empmetrics-display>-->
             <!-- BUHead Wise -->
             <app-Empmetrics-display [data]="aBUHeadL" [groupLabel]="'BUHead'" [groupBy]="'BUHead'" chartTitle="BU Head Wise Metrics"></app-Empmetrics-display>
           </div>
         </div>

         <div class="tab-pane" id="divConsecutive" style="height: 78vh; overflow: hidden;"
              *ngIf="(aproductivityL?.length || 0) > 0 || (aOccupancyL?.length || 0) > 0">
           <div style="height: 100%; overflow-y: auto; padding-right: 0.5rem;">

             <app-consecutive-report *ngIf="(aproductivityL?.length || 0) > 0"
                                     [chartTitle]="'Productivity Overview'"
                                     [data]="aproductivityL"
                                     [metricKey]="'Productivity'">
             </app-consecutive-report>

             <app-consecutive-report *ngIf="(aOccupancyL?.length || 0) > 0"
                                     [chartTitle]="'Occupancy Overview'"
                                     [data]="aOccupancyL"
                                     [metricKey]="'Occupancy'">
             </app-consecutive-report>

           </div>
         </div>


         <div class="tab-pane" id="divApproval">
           <!-- Filter Section -->
           <div *ngIf="isDataAvailable" id="mainFilter" class="d-flex justify-content-between align-items-center mb-3 flex-wrap">
             <!-- Left: BU Head Dropdown and Buttons -->
             <div class="d-flex align-items-center gap-2 mb-2 mb-md-0">

               <label for="buheadFilter">BU Head:</label>
               <select class="form-control" [(ngModel)]="selectedBUHeadId" id="buheadFilter">
                 <option value="">All</option>
                 <option *ngFor="let bu of uniqueBUHeads" [value]="bu.BUHeadId">{{ bu.BUHeadName }}</option>
               </select>

               <button class="btn btn-primary btn-sm" (click)="applyFilter()">Search</button>
               <button class="btn btn-secondary btn-sm" (click)="resetFilter()">Reset</button>
             </div>

             <!-- Right: Bulk Action Buttons -->
             <div class="d-flex gap-2 align-items-center">
               <button class="btn btn-success btn-sm" (click)="approveAll(true)">Approve All</button>
               <button class="btn btn-info btn-sm text-white" (click)="openBulkNotePopup()">Need More Info All</button>
             </div>
           </div>

           <!-- Scrollable Card Container -->
           <div *ngIf="isDataAvailable" class="scroll-container">
             <!--Loader gif-->
             <div id="LoadingImage">
               <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
             </div>
             <div class="row">
               <div class="col-lg-6 mb-4" *ngFor="let emp of filteredList">
                 <div class="card shadow border-0 rounded-lg" (dblclick)="toggleSelection(emp)">
                   <div class="card-header bg-primary text-white rounded-top">
                     <div class="d-flex justify-content-between align-items-center flex-nowrap w-100 overflow-auto">
                       <!-- Left Info -->
                       <div class="d-flex flex-wrap align-items-center">
                         <div class="me-3"><strong>Name:</strong> {{ emp.LoginName }}</div>
                         <div class="me-3"><strong>Department:</strong> {{ emp.UserDepartmentName }}</div>
                         <div class="me-3"><strong>Role:</strong> {{ emp.New_RoleName }}</div>
                         <div class="me-3"><strong>BU Head:</strong> {{ emp.BUHeadName }}</div>
                       </div>
                       <!-- Right Buttons -->
                       <div class="d-flex gap-2 mt-2 mt-lg-0 align-items-center">

                         <!-- Modern Custom Toggle Switch -->
                         <div class="d-flex align-items-center gap-2">
                           <label class="custom-switch">
                             <input type="checkbox"
                                    [checked]="emp.selected"
                                    (click)="$event.stopPropagation()"
                                    (change)="emp.selected = $event.target.checked">
                             <span class="custom-slider"></span>
                           </label>
                         </div>



                         <button class="btn btn-success btn-sm" (click)="approve(emp, true)">Approve</button>
                         <button id="displayMoreInfo" class="btn btn-secondary btn-sm" *ngIf="emp.ApprovedStatus !== 'Need More Info'" (click)="openNotePopup(emp, false)">MoreInfo</button>

                       </div>
                     </div>
                   </div>
                   <div class="card-body p-3 bg-light">
                     <div class="table-responsive">
                       <table class="table table-bordered table-sm table-striped mb-3">
                         <thead class="table-primary text-center">
                           <tr>
                             <th>Metric</th>
                             <th>Non Production</th>
                             <th>Productivity Achieved</th>
                             <th>Occupancy</th>
                             <th>Punctuality</th>
                             <th>Attendance</th>
                             <th>Daily Target Pages</th>
                           </tr>
                         </thead>
                         <tbody class="text-center">
                           <tr>
                             <td><strong>Old</strong></td>
                             <td>{{ emp.Old_NonProduction }}</td>
                             <td>{{ emp.Old_ProductivtyAchieved }}</td>
                             <td>{{ emp.Old_Occupancy }}</td>
                             <td>{{ emp.Old_Punctuality }}</td>
                             <td>{{ emp.Old_Attendance }}</td>
                             <td>{{ emp.Old_DailyTargetPages }}</td>
                           </tr>
                           <tr>
                             <td><strong>New</strong></td>
                             <td>{{ emp.New_NonProduction }}</td>
                             <td>{{ emp.New_ProductivtyAchieved }}</td>
                             <td>{{ emp.New_Occupancy }}</td>
                             <td>{{ emp.New_Punctuality }}</td>
                             <td>{{ emp.New_Attendance }}</td>
                             <td>{{ emp.New_DailyTargetPages }}</td>
                           </tr>
                         </tbody>
                       </table>
                     </div>
                     <!-- BU Head Note (conditionally shown) -->
                     <div *ngIf="emp.BUHeadComment && emp.BUHeadComment.trim() !== ''" class="mt-2">
                       <strong>BU Head Comment:</strong> {{ emp.BUHeadComment }}
                     </div>
                     <div *ngIf="emp.BUHeadNote && emp.BUHeadNote.trim() !== ''" class="mt-2">
                       <strong>BU Head Note:</strong> {{ emp.BUHeadNote }}
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </div>

           <div *ngIf="!isDataAvailable" class="d-flex justify-content-center mt-5">
             <div class="card shadow-lg border-0 rounded-4 text-center px-5 py-4" style="max-width: 480px; background-color: #f8f9fa;">
               <div class="card-body">
                 <h4 class="card-title text-danger fw-bold mb-3" style="font-size: 1.75rem;">
                   <i class="bi bi-exclamation-circle-fill me-2" style="font-size: 2rem;"></i>
                   No Records Found
                 </h4>
               </div>
             </div>
           </div>

           <!-- Note Popup -->
           <div *ngIf="selectedEmpForNote" class="popup-overlay">
             <div class="popup-box large-popup">
               <h5>Add Note</h5>
               <textarea [(ngModel)]="noteText"
                         class="form-control mb-3"
                         rows="8"
                         style="resize: none; height: 200px;"></textarea>
               <div class="d-flex justify-content-end">
                 <button class="btn btn-secondary me-2" (click)="closeNotePopup()">Close</button>
                 <button class="btn btn-primary" (click)="saveNote()">Need More Info</button>
               </div>
             </div>
           </div>


           <div *ngIf="showNoteTextarea" class="popup-overlay">
             <div class="popup-box large-popup">
               <h5>Add Note</h5>
               <textarea [(ngModel)]="noteInput"
                         class="form-control mb-3"
                         rows="8"
                         style="resize: none; height: 200px;"></textarea>
               <div class="d-flex justify-content-end">
                 <button class="btn btn-secondary me-2" (click)="cancelNote()">Close</button>
                 <button class="btn btn-primary" (click)="OverAllsaveNote()">Save</button>
               </div>
             </div>
           </div>
         </div>

       </div>
</div>





